// Smart Sash Admin Panel - Auth Callback Component
// Handles OAuth callback and redirects

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Auth Callback Component
 * Handles redirect after OAuth authentication
 */
export const AuthCallback: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Get the redirect path from session storage
    const redirectPath = sessionStorage.getItem('redirectAfterLogin') || '/dashboard';
    sessionStorage.removeItem('redirectAfterLogin');

    // Redirect to the original destination
    navigate(redirectPath, { replace: true });
  }, [navigate]);

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center">
      <div className="text-center">
        <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="text-muted">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
